module.exports = __webpack_public_path__ + "static/media/linkedin.d5b87507.svg";